module.exports = __webpack_public_path__ + "static/media/beleidskeuze.04d9d355.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/beleidskeuze.svg
// module id = 115
// module chunks = 0